import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://www.linkedin.com/in/tharun-reddy-dubba-597557115/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://github.com/Tharun98',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.facebook.com/profile.php?id=100009370049635',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/tharundtr/',
    label: 'Instagram',
    icon: faInstagram,
  },
  {
    link: 'https://twitter.com/tharundtr',
    label: 'Twitter',
    icon: faTwitter,
  },
  {
    link: 'mailto:tharunreddydubba@gmail.com',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
